<div class="dropdown">
	<button class="dropbtn t-language" id="selected-country" (click)="toggle()">
		<img src="../../../assets/flags/{{ countryNameS }}.png" />
		<div class="dropbtn-text">{{ 'A001Country' | translate: lang }}</div>
	</button>
	@if (isOpen) {
	<div class="dropdown-content" id="idCountryList">
		<ul>
			@for (country of countries; track country) {
			<li
				class="t-language-{{ country.key }}"
				(click)="countrySelect(country)"
			>
				<img
					src="../../../assets/flags/{{ country.name }}.png"
					class="flag"
				/>{{ country.name | translate: lang }}
			</li>
			}
		</ul>
	</div>
	}
</div>
